import React from 'react';
import { ArrowRight, Star, PlayCircle, Sparkles } from 'lucide-react';

const AVATARS = [
  { color: '#F4B93E', initial: 'A' },
  { color: '#E64B2B', initial: 'R' },
  { color: '#4FB3B8', initial: 'P' },
  { color: '#7BB7DC', initial: 'S' },
];

const STAR_KEYS = ['s1', 's2', 's3', 's4', 's5'];

export default function HeroContent() {
  return (
    <div className="lg:col-span-7">
      <span className="inline-flex items-center gap-2 bg-[#4FB3B8]/15 text-[#2C3E50] px-3 py-1.5 rounded-full text-sm font-bold border border-[#4FB3B8]/40">
        <Sparkles size={14} className="text-[#E64B2B]" /> FREE Demo Class · No advance payment
      </span>
      <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] text-[#2C3E50]">
        Experienced <span className="text-[#E64B2B]">Home Tutors</span> for <br className="hidden sm:block"/>
        <span className="wobble-underline text-[#2C3E50]">every class, every subject.</span>
      </h1>
      <p className="mt-5 text-lg text-[#2C3E50]/80 max-w-xl leading-relaxed">
        Personalised one-on-one coaching that meets your child where they are and takes them where they deserve to be. From Pre-KG scribbles to Class 12 board exams — we bring the classroom home.
      </p>

      <div className="mt-7 flex flex-wrap items-center gap-4">
        <a href="#contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#F4B93E] text-[#2C3E50] font-black border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5">
          Book a Free Demo <ArrowRight size={18} />
        </a>
        <a href="#how" className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-transparent text-[#2C3E50] font-bold border-2 border-[#2C3E50] hover:bg-[#2C3E50] hover:text-[#FFF8EC]">
          <PlayCircle size={18} /> How it works
        </a>
      </div>

      <div className="mt-8 flex items-center gap-5">
        <div className="flex -space-x-3">
          {AVATARS.map(({ color, initial }) => (
            <div key={initial} className="w-10 h-10 rounded-full border-2 border-[#FFF8EC] flex items-center justify-center text-white font-bold" style={{ background: color }}>
              {initial}
            </div>
          ))}
        </div>
        <div>
          <div className="flex items-center gap-1 text-[#F4B93E]">
            {STAR_KEYS.map((k) => (
              <Star key={k} size={16} fill="#F4B93E" strokeWidth={0} />
            ))}
            <span className="ml-2 text-[#2C3E50] font-bold">4.9 / 5</span>
          </div>
          <div className="text-sm text-[#2C3E50]/70 font-medium">from 2,252+ happy parents</div>
        </div>
      </div>
    </div>
  );
}
